<mat-sidenav-container class="ui-interface">
  <mat-sidenav #sidenav class="ui-sidenav" [mode]="(screen.width > 768 ? 'side' : 'over')" [opened]="screen.width > 768 && interfase">
     
    <div class="ui-sidenav-container">
      <div>
        <div class="ui-sidenav-header">
          <div class="ui-sidenav-logo"></div>
            
          <div class="ui-sidenav-user" *ngIf="user">
            <div class="user-data">
              <div class="user-name">{{user.firstname}} {{user.lastname}}</div>
              <div class="user-account">{{user.client}} - {{accountStatus(user.status)}}</div>
            </div>

            <a class="user-select" [matMenuTriggerFor]="accounts" *ngIf="!user.isAdmin"><mat-icon aria-label="Cambiar de cuenta">keyboard_arrow_down</mat-icon></a>
            <a class="user-select" (click)="onAdminAccountSearch()" *ngIf="user.isAdmin"><mat-icon aria-label="Administrar cuenta">recent_actors</mat-icon></a>

            <mat-menu #accounts="matMenu" class="accounts-menu">
              <button mat-menu-item class="accounts-menu-item" *ngFor="let account of user.accounts" (click)="onAccountSelect(account.number)">
                <h6>{{account.name}}</h6> <span>{{account.number}} - {{accountStatus(account.status)}}</span>
              </button>
            </mat-menu>
          </div>
        </div>
      
        <div class="ui-sidenav-content">
          <ul>
            <li *ngFor="let item of menuItems">
              <a class="ui-sidenav-item" *ngIf="item.menu == 'principal'" (click)="(screen.width < 768 ? sidenav.close() : ''); (item.action ? item.action() : '');" [routerLink]="[item.route != '' ? item.route : './']" [routerLinkActive]="item.route != '' ? 'ui-sidenav-item-active' : ''">
                <mat-icon class="ui-item-icon">{{item.icon}}</mat-icon>
                <span class="ui-item-text">{{item.title}}</span>
              </a>
            </li>
          </ul>
            
          <div class="ui-separator"></div>
            
          <ul>
            <li *ngFor="let item of menuItems">
              <a class="ui-sidenav-item" *ngIf="item.menu == 'secundario'" (click)="(screen.width < 768 ? sidenav.close() : ''); (item.action ? item.action() : '');">
                <mat-icon class="ui-item-icon">{{item.icon}}</mat-icon>
                <span class="ui-item-text">{{item.title}}</span>
              </a>
            </li>
          </ul>

          <div *ngIf="user">
            <div class="ui-separator"></div>

            <div class="ui-sidenav-account-unsuscribe" *ngIf="!user.unsuscribeAccount">
              <button mat-stroked-button class="ui-button" (click)="onUnsuscribe()">Dar de baja mi cuenta</button>
            </div>

            <div class="ui-sidenav-account-unsuscribe" *ngIf="user.unsuscribeAccount || user.unsuscribeServices">
              <span>Si solicitaste alguna baja estas a tiempo de cancelarla</span>
              <button mat-stroked-button class="ui-button" (click)="onUnsuscribeCancel()">Cancelar bajas solicitadas</button>   
            </div>
          </div>
        </div>
      </div>

      <div class="ui-sidenav-footer">
        <ul>
          <li>
            <a class="ui-sidenav-item" href="https://www.iptel.com.ar/contacto" target="_blank">
              <mat-icon class="ui-item-icon">room</mat-icon><span class="ui-item-text">Centros de contacto</span>
            </a>
          </li>
          <li>
            <a class="ui-sidenav-item" href="tel:+543515890000" target="_blank">
              <mat-icon class="ui-item-icon">call</mat-icon><span class="ui-item-text">0351 589 0000</span>
            </a>
          </li>
          <li>
            <a class="ui-sidenav-item" href="tel:+54160090000" target="_blank">
              <mat-icon class="ui-item-icon">call</mat-icon><span class="ui-item-text">01 6009 0000</span>
            </a>
          </li>
          <li>
            <a class="ui-sidenav-item" href="tel:+543462462000" target="_blank">
              <mat-icon class="ui-item-icon">call</mat-icon><span class="ui-item-text">03462 462 000</span>
            </a>
          </li>
          <li>
            <a class="ui-sidenav-item" href="mailto:iptel@iptel.com.ar" target="_blank">
              <mat-icon class="ui-item-icon">email</mat-icon><span class="ui-item-text">iptel&#64;iptel.com.ar</span>
            </a>
          </li>
        </ul>

        <div class="ui-sidenav-social">
          <a href="https://twitter.com/iptelargentina" target="_blank"><i class="fab fa-twitter"></i></a>
          <a href="https://www.facebook.com/iptelargentina" target="_blank"><i class="fab fa-facebook-f"></i></a>
          <a href="https://wa.link/niwfzy" target="_blank"><i class="fab fa-whatsapp"></i></a>
        </div>
      </div>
    </div>
  </mat-sidenav>
    
  <mat-sidenav-content class="ui-canva" [ngClass]="!interfase ? 'ui-canva-full' : ''">
    <mat-toolbar class="ui-toolbar" [ngClass]="navbarConfig.navbarDouble ? '' : 'mat-elevation-z2'"  *ngIf="interfase">
      <mat-toolbar-row>
        <button mat-icon-button (click)="sidenav.toggle()" *ngIf="navbarConfig.menuButtonShow">
          <mat-icon aria-label="Menu">menu</mat-icon>
        </button>        
      
        <h6 class="ui-toolbar-title">{{navbarConfig.title}}</h6>
      </mat-toolbar-row>
    </mat-toolbar>
      
    <router-outlet></router-outlet>
      
    <button mat-fab color="primary" class="ui-button-fab chat-button" *ngIf="interfase">
      <mat-icon>chat</mat-icon>
    </button>
  </mat-sidenav-content>
</mat-sidenav-container>

<app-ui-spinner></app-ui-spinner>